import React, { Suspense } from 'react';
import { useTheme } from '../../hooks';

const MonacoEditor = React.lazy(() => import('@monaco-editor/react'));

const HtmlEmailEditor = ({ value, onChange, minHeight = 400 }) => {
  const { theme } = useTheme();

  return (
    <div style={{ minHeight, border: '1px solid #e5e7eb', borderRadius: 6, overflow: 'hidden' }}>
      <Suspense fallback={<div className="p-4 text-sm text-gray-500">Loading editor...</div>}>
        <MonacoEditor
          height={`${minHeight}px`}
          language="html"
          theme={theme === 'dark' ? 'vs-dark' : 'light'}
          value={value}
          onChange={onChange}
          options={{
            minimap: { enabled: false },
            wordWrap: 'on',
            scrollBeyondLastLine: false,
            fontSize: 13,
            tabSize: 2,
          }}
        />
      </Suspense>
    </div>
  );
};

export default HtmlEmailEditor;
